import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClinicCombobox } from '@/components/shared/ClinicCombobox';
/**
 * Header row for a per-clinic settings panel (Schedule, Report design, report
 * branding): the panel's title block on the left, the "which clinic am I
 * editing" picker on the right.
 *
 * The picker never shrinks: as a plain flex item it was squeezed to ~83px on
 * phones, so every clinic read "Previe…" and a multi-clinic admin could not
 * tell which clinic they were about to change. Below sm the row wraps and the
 * picker takes the full width under the title; from sm up it is the usual
 * 180px trigger beside it.
 */
export function ClinicScopeHeader({ children, clinics, value, onValueChange, ariaLabel, showPicker, }) {
    return (_jsxs("div", { className: "flex flex-wrap items-start justify-between gap-2", children: [_jsx("div", { className: "min-w-0 flex-1 basis-60", children: children }), showPicker && value && (_jsx(ClinicCombobox, { clinics: clinics, value: value, onChange: onValueChange, "aria-label": ariaLabel, "data-testid": "clinic-scope-select", className: "h-7 text-xs pointer-coarse:h-10", wrapperClassName: "w-full shrink-0 sm:w-[180px]" }))] }));
}
